import { createCommand } from '../../utils';
import type { Project } from '../ExternalProjectPort';
import { moduleName } from '../state';

export const LoadProjectsCommand = createCommand<void, Project[]>(
    `${moduleName}/LOAD_PROJECTS`,
    async (_, { extra }) => {
        return extra.externalProject.loadProjects();
    },
);
